/** 任务分组类型：本站发出 / 本站到达 */
export enum TaskGroupType {
    Departure = 'departure',
    Arrival = 'arrival'
}

// 承运商信息（Carrier）- 共享的
export interface BolCarrierInfo {
    carrierName: string;
    trailerNumber: string;
    truckNumber: string;
    licensePlate: string;
    proNumber?: string;
    vehicleModel: string;
    driver1Name?: string;
    driver1Phone?: string;
    driver2Name?: string;
    driver2Phone?: string;
}

// 途经点信息（Waypoint/Stop）
// stops[0]: 始发站（SHIP FROM，shipTo* 即本站信息）；stops[i>0]: 第 i 段（shipFrom* -> shipTo*）
export interface BolStop {
    segment: number;
    shipFromId: string;
    shipFromAddress: string;
    shipFromContactName: string;
    shipFromContactPhoneNumber: string;
    shipFromSortCode?: string;

    shipToId: string;
    shipToAddress: string;
    shipToCityStateZipcode: string;
    shipToContactName: string;
    shipToContactPhoneNumber: string;
    shipToSortCode: string;

    planArrivalLocalDate?: string | null;
    planArrivalLocalTime?: string | null;
    planArrivalLocalTimezone?: string | null;
    planArrivalTimezoneLocation?: string | null;

    /** 到达站 Static ETA（发车后级联计算，来自 tms_task_waypoint.static_eta_*；时区与到达站一致，赋值取 planArrival 对应字段） */
    staticEtaDate?: string | null;
    staticEtaTime?: string | null;
    staticEtaLocalTimezone?: string | null;
    staticEtaTimezoneLocation?: string | null;

    sealNumber: string;

    /** 签名表：实际到达/离开时间（有值才展示，如 "10:23  07/20/2026"） */
    arriveTime?: string | null;
    departTime?: string | null;
    /** 签名表：司机 / 仓库签名 */
    driverSignature?: string | null;
    warehouseSignature?: string | null;
}

/** 包牌明细 */
export interface BagDetail {
    bagNumber: string;
    parcelCount: number;
    /** 单包重量（LB），后端暂未提供时为空 */
    weight?: number | null;
}

/** 站点容器明细（按类型聚合，来源=装车），containerType：1-卡板箱 2-蛇皮袋 3-托盘 4-Gaylord */
export interface StationContainerDetail {
    containerType: number;
    containerCount: number;
}

/** 站点装载明细（Loading Information 按目的仓分组） */
export interface StationLoadingDetail {
    stationCode: string;
    /** 装车容器列表（按类型聚合），展示为 "数量/类型"，如 "10/卡板箱" */
    containers?: StationContainerDetail[];
    bags: BagDetail[];
}

// BOL v3 数据结构（BOL Of Loading：单据 + 装车明细合一）
export interface BolDataV3 {
    // Identifiers
    taskId: string;
    date: string;
    routeName: string;
    routeCode: string;
    billOfLadingNumber: string;
    /** 外部运单号 */
    freightOrderId: string;

    // 任务级业务属性（用于按业务类型/路线类型/交接方类型控制展示与校验）
    businessType?: number;
    /** 任务类型：1-常规 2-临时 3-三方（三方任务分多段，按普通样式的多列版式展示） */
    taskType?: number;
    routeType?: number;
    carrierSourceType?: number; // 交接方类型：1-本地尾程商 2-干线承运商，仅交接任务有值

    // Carrier Info (shared across all stops)
    carrier: BolCarrierInfo;

    // Stops (array of waypoints)
    stops: BolStop[];

    // Remark
    remark?: string;

    // Loading Information（按目的仓分组的装载明细）
    loadingDetails: StationLoadingDetail[];

    /** 重量单位，默认 LB */
    weightUnit?: string;
}
